export default "__VITE_ASSET__DUnPNaIp__"